/**
 * This file is an alternative of `product-model.js` on Shopify.
 * It overloads the default model-viewer with the `webgi-viewer` from the iJewel3D SDK(https://ijewel3d.com).
 * This file must be included in the theme manually, and referenced in the pages where product-model.js was used.
 * Check the docs for more information and updates. - https://developer.ijewel3d.com/integrations/shopify
 *
 * File version - 31-07-2024
 */

// Settings for the iJewel3D SDK, this includes the webgi package version, environment maps etc.
// This can be set externally in the metafields or in the page where the product model is used, if not, the default settings will be used.
window.iJewelSDKSettings = {
    webgi_version: "0.9.14",
    scene_settings: "",
    environment_map: "",
    license_key: "KX5KKR3QFBMFE2TDZ82TRRWZTQP44W8W-ZTKPHC4SW8",
    loading: {
        loadingTextHeader: "Laden...",
        showFileNames: false,
        backgroundOpacity: 0.5,
        background: "#ECECECE",
        textColor: "#222222",
        logoImage: "https://cdn.shopify.com/s/files/1/0564/5795/3460/files/VEYNOU_Logo.svg?v=1683810395",
    },
    ...(window.iJewelSDKSettings||{}),
}

// Create a custom model-viewer element that extends the HTMLElement, this will be used to load the iJewel3D SDK viewer.
// Note that it has to be made sure that this should be run before loading the google model viewer, since we cannot redefine an html element.
if(!customElements.get('model-viewer')){
    const viewerScript = document.createElement('script');
    viewerScript.setAttribute('src',
        window.iJewelSDKSettings.webgi_version.includes('/') ? window.iJewelSDKSettings.webgi_version : // assume URL
            'https://dist.pixotronics.com/webgi/runtime/viewer-'+(window.iJewelSDKSettings.webgi_version||'0.9.14')+'.js'
    );
    document.head.appendChild(viewerScript);
    //todo: fix for proper multiple viewer support.
    let globalViewer = null; // to make sure we use only 1 viewer and canvas on a page,
    customElements.define('model-viewer', class ModelViewerWebGi extends HTMLElement{
        constructor() {
            super();
            const container = document.createElement('div')
            this.container = container
            this.container.style.width = "100%"
            this.container.style.height = "100%"
            this.appendChild(container)

            this.modelLoaded = false;

            this.initialize()
        }


        doOnLoad(fn){
            if(this.modelLoaded) fn()
            this.onLoad = fn;
        }

        async initialize(){
            if(globalViewer) {
                if(globalViewer === 1) return
                this.viewer = globalViewer
                this.viewer.scene.removeSceneModels()
            }else {
                globalViewer = 1;
                this.viewer = new CoreViewerApp({container: this.container})
                await this.viewer.initialize({caching: true, ground: true, bloom: true, enableDrop: false, importPopup: true, debug: false})
                this.viewer.getPluginByType('Diamond').setKey(window.iJewelSDKSettings.license_key)
                globalViewer = this.viewer;
                this.viewer.canvas.style.width = "100%"
                this.viewer.canvas.style.height = "100%"
            }
            const src = this.getAttribute('src')
            let envMapPromise = null
            this.refreshLoadingScreen()
            if(window.iJewelSDKSettings.environment_map && window.iJewelSDKSettings.environment_map.length){
                envMapPromise = this.viewer.getManager().importer.importSinglePath(window.iJewelSDKSettings.environment_map)
            }
            const modelPromise = this.viewer.load(src)
            const [model, envMap] = await Promise.all([modelPromise, envMapPromise])
            this.refreshLoadingScreen()
            if(window.iJewelSDKSettings.scene_settings && window.iJewelSDKSettings.scene_settings.length){
                await this.viewer.load(window.iJewelSDKSettings.scene_settings)
            }
            this.refreshLoadingScreen()
            if(envMap) this.viewer.scene.setEnvironment(envMap)
            this.modelLoaded = true

            // await timeout(200)
            setTimeout(()=>{
                if(this.onLoad) this.onLoad()
                window.dispatchEvent(new CustomEvent('ijewel-viewer-loaded', {detail: this}))
            }, 200)

        }

        refreshLoadingScreen(){
            const loadingSettings = window.iJewelSDKSettings.loading ?? {}
            const loadingPlugin = this.viewer.getPluginByType('LoadingScreenPlugin')
            Object.entries(loadingSettings).forEach(([key, value])=>{
                loadingPlugin[key] = value
            })
        }

    })
}


// Create a custom ProductModel element that extends the DeferredMedia element, this disables loading of google-model-viewer
if (!customElements.get('product-model')) {
    customElements.define('product-model', class ProductModel extends DeferredMedia {
        constructor() {
            super();
            const template = this.querySelector('template')
            const viewer = template.content.querySelector('model-viewer')
            delete viewer.dataset.shopifyFeature // disables loading of google model viewer script by shopify
        }

        loadContent() {
            super.loadContent();

            const poster = this.querySelector('.deferred-media__poster')
            poster.style.display = 'block'
            poster.style.zIndex = 100;
            const posterButton = this.querySelector('.deferred-media__poster-button')
            posterButton.style.display = 'none'

            const modelViewer = this.querySelector('model-viewer')
            modelViewer.doOnLoad(()=>{
                poster.style.display = 'none'
            })
        }

        setupModelViewerUI(errors) {
            if (errors) return;
        }
    });
}

// Set a dummy ProductModel in the window, just in case
window.ProductModel = {
    loadShopifyXR() {
    },

    setupShopifyXR(errors) {
        if (errors) return;
    },
};